module.exports = __webpack_public_path__ + "static/media/approach-tea.c6672196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approach-tea.jpg
// module id = 141
// module chunks = 0